<template>
  <div id="app">
    <router-view/>
    <van-popup v-model="showOffLine" :style="{ width: '279px', 'background-color':  'transparent'}">
      <div style="padding-top: 40px;padding-bottom: 51px;background-color: #fff;border-radius: 5px">
        <div style="width: 100px;height: 100px;margin: auto">
          <img :src="require('@/assets/images/off-line-icon.png')" style="width: 100%;height: 100%">
        </div>
        <div style="text-align: center;color: #333333;font-size: 16px;line-height: 21px;margin-top: 20px;padding: 0 59px">
          该机器已经离线，无法购买， 请联系客服！
        </div>
        <div class="btn-success" style="margin-top: 31px">完成</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import { ConfigApi, PayApi } from "@/apis";
  import { mapState, mapMutations } from 'vuex'

  export default {
    data() {
      return {
        showOffLine: false,
        querySearch: {}
      }
    },
    computed: {
      ...mapState({
        code: 'code',
        alipayCode: 'alipayCode'
      })
    },
    created() {
      this.querySearch = this.getLcationSearch()
      console.log('querySearch', this.querySearch)
      this.getWechatCode()
      this.getAlipayCode()
    },
    methods: {
      ...mapMutations({
        setIsCanPayByWeixin: 'setIsCanPayByWeixin',
        setCode: 'setCode',
        setOpenId: 'setOpenId',
        setAlipayCode: 'setAlipayCode',
      }),
      isWechatFn() {
        //获取user-agaent标识头
        let ua = window.navigator.userAgent.toLowerCase();
        //判断ua和微信浏览器的标识头是否匹配
        if (ua.match(/micromessenger/i) == 'micromessenger') {
          return true;
        } else {
          return false;
        }
      },
      isAlipayFn() {
        const ua = navigator.userAgent.toLowerCase()
        return /AlipayClient|AliApp\(AP/i.test(ua);
      },
      getWechatCode() {
        if (this.isWechatFn()) {
          //let appid = "wxf701781932f27276"; //微信APPid
          let appid = "wx2f621673cafbf4ed"; //微信APPid
          let code = this.querySearch.code; //是否存在code
          if (!code) {
            let locationHref = window.location.href
            //不存在就打开上面的地址进行授权
            window.location.href =
                "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
                appid +
                "&redirect_uri=" +
                encodeURIComponent(locationHref) +
                "&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect";
          } else {
            this.setCode(code)
            console.log('this.code:',  this.code)
            this.getOpenId()
          }
        }
      },
      getAlipayCode() {
        if (this.isAlipayFn()) {
          let appid = "2021005173657455"
          //console.log('appid= ' + JSON.stringify(appid))
          ap.getAuthCode ({
            appId : appid ,
            // scopes : ['auth_user'],
            scopes : ['auth_base'],
          }, (res) => {
            //ap.alert (JSON.stringify(res));
            //console.log('res= ' + JSON.stringify(res))
            let authCode = res.authCode
            // let state = res.state
            let locationHref = window.location.href
            let params = {
              auth_code: authCode,
              state: locationHref
            }
            PayApi.getUserId(params).then((respon) => {
              console.log('respon= ' + JSON.stringify(respon))
              if (respon.code === 200) {
                this.setAlipayCode(respon.data)
              }
            })
          });
        }
      },
      getLcationSearch() {
        let obj = {}
        let str = window.location.href.split('?')[1] || ''
        let strArr = str.split('&') || []
        strArr.forEach((ev) => {
          let evArr = ev.split('=')
          obj[evArr[0]] = evArr[1]
        })
        return obj
      },
      getOpenId() {
        let params = {
          code: this.code
        }
        ConfigApi.getApiGetopenid(params).then((res) => {
          if (res.code === 200) {
            if (res.data && res.data.openid) {
              this.setIsCanPayByWeixin(true)
              this.setOpenId(res.data.openid)
            }
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .btn-success {
    width: 196px;
    height: 42px;
    background: linear-gradient(270deg, #98C3C4 0%, #D1EBE6 100%);
    box-shadow: 0px 5px 10px 1px rgba(75,122,123,0.1);
    border-radius: 100px 100px 100px 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 16px;
    margin: auto;
  }
</style>
